import { DummyStore } from 'stores';

import { SynchronizationResponse } from '../types/synchronization-response.type';

export namespace SynchronizationsStore {
  export const synchronizations = new DummyStore<SynchronizationResponse>();
}
